/**
 * User: gedas
 * Date: 2/25/16
 * Time: 4:00 PM
 */
'use strict';

const SV = require('server-vars');

module.exports = {
    /**
     * @returns {Object}
     * @private
     */
    _getConfig() {
        return SV.get('settings.enabler') || {};
    },

    /**
     * Checks if key in config is set and its `true`
     *
     * @param {String} key
     * @returns {Boolean}
     */
    isEnabled(key = '') {
        const config = this._getConfig();
        return typeof config[key] !== 'undefined' && config[key] === true;
    },
};



// WEBPACK FOOTER //
// ./assets/js/global/utils/enabler.es.js